/* =============================================================
 * import
 * ========================================================== */
import {gsap} from 'gsap';
import {CustomEase} from "gsap/CustomEase";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(CustomEase, ScrollTrigger);
CustomEase.create("fadeCurtain", ".25, .46, .45, .94");
CustomEase.create("fade", "0.5, 1, 0.89, 1");

export default function subKvAnimation(elm, barba = false) {

  const tl = gsap.timeline();
  const nextMv = elm.querySelector('.kv');
  const nextMvTtl = elm.querySelector('.kv .school_top_kv_headline');
  const nextMvImg = elm.querySelector('.kv .school_top_kv_figure_img');
  const filterWrap = document.querySelector('.filter_bg');
  let filter;

  if (elm.classList.contains('senior') && elm.classList.contains('school_top')) {
    filter = document.querySelector('#transition_senior');
  } else if (elm.classList.contains('junior') && elm.classList.contains('school_top')) {
    filter = document.querySelector('#transition_junior');
  }

  if (filter && nextMv) {
    gsap.set(filter, {
      autoAlpha: 0,
      scale: 1,
    });
    gsap.set(nextMvTtl, {
      autoAlpha: 0,
    });
    gsap.set(nextMvImg, {
      autoAlpha: 0,
      scale: 1,
    });

    const animate = () => {
      tl
        .to(filter, {
          autoAlpha: 1,
          ease: "fade",
          duration: 1.5,
        })
        .to(filter, {
          scale: 1.2,
          ease: "fade",
          duration: 5,
        }, "<")
        .to(nextMvImg, {
          autoAlpha: 1,
          ease: "fade",
          duration: 2,
        }, "<+=1")
        .to(nextMvImg, {
          scale: 1.1,
          ease: "fade",
          duration: 6,
        }, "<")
        .to(nextMvTtl, {
          autoAlpha: 1,
          ease: "fade",
          duration: 1,
        }, "<+=.8")
      ;
    };

    // Barba.jsの遷移後に呼ばれた場合と、通常のロード時の分岐
    if (barba) {
      // Barba.jsの遷移後
      animate();
    } else {
      // アニメーション開始時の要素設定
      window.onload = function() {
        animate();
      };
    }

    gsap.to(filterWrap, {
      scale: 1.1,
      opacity: 0,
      scrollTrigger: {
        trigger: nextMv,
        start: "bottom top+=50%",
        end: 'bottom top-=50%',
        pinSpacing: false,
        scrub: 1,
        invalidateOnRefresh: true, // update on resize
      },
    });
  }
}